<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { Sonner } from '@youcan/celeste';
import AnnouncementBanners from '@/components/announcements/banners-carousel.vue';
import Milestones from '@/pages/home/_components/milestones.vue';

useFlash();

const page = usePage();
const bp = useBreakpoints(breakpointsTailwind);

const isMobile = bp.smaller('lg');
</script>

<template>
  <Sonner />
  <div class="layout">
    <Topbar id="topbar" />

    <div class="sublayout container xl:max-w-screen-xl">
      <aside v-if="!isMobile">
        <Sidebar id="sidebar" />
        <Milestones v-if="!isMobile" />
      </aside>

      <div class="inner">
        <!-- START BANNERS -->

        <AnnouncementBanners />

        <!-- END BANNERS -->

        <!-- START NOTICES  -->

        <EmailUpdatePending
          v-if="page.props.email_marked_for_update"
          :email="page.props.email_marked_for_update"
        />

        <!-- END NOTICES  -->

        <Milestones v-if="isMobile" />

        <slot />
      </div>
    </div>
  </div>
</template>

<style>
:root {
  --topbar-height: 52px;
}

html {
  background: var(--color-bg-weak-50);
}

.layout {
  position: relative;
  max-width: 100vw;
  min-height: 100svh;
}

#topbar {
  position: sticky;
  top: 0;
  margin-bottom: 24px;
}

.sublayout {
  display: grid;
  grid-template-columns: 244px 1fr;
  margin: 0 auto;
  gap: 24px;
  padding-bottom: 24px;
}

.sublayout > aside {
  position: sticky;
  top: calc(var(--topbar-height) + 24px);
  grid-column: 1;
  grid-row: 1;
  align-self: flex-start;
  max-height: calc(100vh - var(--topbar-height) - 48px);
  overflow-y: auto;
}

.sublayout aside > * + * {
  margin-top: 24px;
}

.sublayout > .inner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  overflow: hidden;
}

@screen lt-lg {
  html {
    background: var(--color-bg-white-0);
  }

  .layout {
    overflow: visible;
  }

  .sublayout {
    grid-template-columns: 1fr;
  }

  .sublayout > aside {
    display: none;
  }

  .sublayout > .inner {
    padding: 0 4%;
  }
}
</style>
